export default __webpack_public_path__ + "static/logo-mfs-f99f357d2509c5a33d40a6de3c8b1263.png";